import React from 'react'
import { Box, Divider, Flex, Text } from '@chilipiper/design-system'
import { endSession } from '@chilipiper/service/src/session'
import { LabelToggle, Icon } from '@chilipiper/design-system/src/new'
import { Link } from 'react-router-dom'
import {
  IconArrowLeftBarLeft,
  IconUser,
  IconChevronRight,
} from '@chilipiper/icons/figma-generated/src/icon'
import { routes } from '../../../routes/routes'
import { StyledHoverButton } from './styled'
import { useShouldShowOnlineToggle } from '@/hooks/useShouldShowOnlineToggle'
type Props = {
  isUserAway: boolean
  onMenuItemClick: () => void
  onToggleAwayMode: () => void
}

export const PersonalSettingsMenu = ({ onToggleAwayMode, onMenuItemClick, isUserAway }: Props) => {
  const shouldShowOnlineToggle = useShouldShowOnlineToggle()

  return (
    <Box borderRadius={8} boxShadow='border/popover'>
      <Box borderRadius={8} overflow='hidden' w='250px' bg='bg/minor' as='ul'>
        {shouldShowOnlineToggle && (
          <>
            <LabelToggle
              onChange={() => onToggleAwayMode()}
              label={<LabelToggle.Label>{isUserAway ? 'Offline' : 'Online'}</LabelToggle.Label>}
              variant='nested'
              isChecked={!isUserAway}
            />
            <Divider />
          </>
        )}
        <StyledHoverButton as='li'>
          <Link to={routes.personalSettings.personalDetails} onClick={onMenuItemClick}>
            <Flex
              px={4}
              py={3}
              alignItems='center'
              boxShadow='border/row'
              justifyContent='space-between'
            >
              <Flex alignItems='center'>
                <Icon icon={IconUser} mr={3} color='fg/moderate' />
                <Text textStyle='item-unselected' color='fg/major'>
                  Personal Settings
                </Text>
              </Flex>
              <Icon icon={IconChevronRight} color='fg/moderate' />
            </Flex>
          </Link>
        </StyledHoverButton>

        <li>
          <StyledHoverButton
            onClick={() => {
              onMenuItemClick()
              endSession()
            }}
            width='100%'
            display='flex'
            px={4}
            py={3}
          >
            <Icon icon={IconArrowLeftBarLeft} mr={3} color='fg/moderate' />
            <Text textStyle='item-unselected' color='fg/major'>
              Log out
            </Text>
          </StyledHoverButton>
        </li>
      </Box>
    </Box>
  )
}
